import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import SectionWrapper from 'components/SectionWrapper'
import { RU } from 'constants/countries'
import { LocalizationContext } from 'contexts/Localization'
import { Text } from 'styles/components/typography'

import burgerBan from './assets/burger-ban.svg'
import TubeSpit from './components/TubeSpit'
import TubeSwab from './components/TubeSwab'
import { EatIcon } from './styles'

/**
 * DHowSpit
 *
 * @param {object} props - properties of component
 * @returns {node} DHowSpit
 */
const DHowSpit = ({ data, index, isSquareHidden, locale }) => {
  const { colors } = React.useContext(ThemeContext)
  const {
    paths: { shared },
  } = React.useContext(LocalizationContext)
  const imagesPath = `${shared}/dna_how/how_spit_`

  return (
    <SectionWrapper
      isOverflowHidden={true}
      classNameWrapper="bg--purple--light"
    >
      <HowToBlock
        isSquareHidden={isSquareHidden}
        title={data.title}
        index={index}
        squareColor={colors.pictonBlue}
        lineColor="light"
      >
        <div className="row">
          <div className="col-12 col-md-5 col-lg-5 offset-md-1 pb-2 pb-md-4 pb-lg-0">
            <div className="mb-2">
              <Text
                className="text--white with-inverted-links"
                dangerouslySetInnerHTML={{ __html: data.content_start }}
              />
            </div>
            <EatIcon alt="" className="mb-2" src={burgerBan} />
            <Text
              className="text--white with-inverted-links"
              dangerouslySetInnerHTML={{ __html: data.content_end }}
            />
          </div>
          <div className="col-12 col-md-6">
            {locale === RU ? (
              <TubeSwab path={imagesPath} />
            ) : (
              <TubeSpit path={imagesPath} />
            )}
          </div>
        </div>
      </HowToBlock>
    </SectionWrapper>
  )
}

DHowSpit.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  locale: PropTypes.string.isRequired,
  isSquareHidden: PropTypes.bool,
}

DHowSpit.defaultProps = {
  isSquareHidden: false,
}

export default DHowSpit
